import { render, staticRenderFns } from "./AllProduct.vue?vue&type=template&id=4ad25ddd&scoped=true&"
import script from "./AllProduct.vue?vue&type=script&lang=js&"
export * from "./AllProduct.vue?vue&type=script&lang=js&"
import style0 from "./AllProduct.vue?vue&type=style&index=0&id=4ad25ddd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad25ddd",
  null
  
)

export default component.exports
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInfiniteScroll,QSpinnerDots});
